"use client";

import { c as _c } from "react/compiler-runtime";
import { IconLock } from "@tabler/icons-react";
import { useRouter } from "next/navigation";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { pushDataLayer } from "@/lib/analytics/datalayer";
import { trackCheckoutStarted } from "@/lib/analytics/segment";
import { useCart } from "@/queries/useCart";
import { useNewCartStore } from "@/stores/useNewCartStore";
import { getRollDriver, needsRollSelection } from "@/utils/rollQuantityUtils";
export const CHECKOUT_ROLL_QUANTITY_ERROR = "Please confirm your roll quantity selection";
export function CartCheckoutButton() {
  const $ = _c(20);
  const router = useRouter();
  const {
    data: cart
  } = useCart();
  const setIsCartOpen = useNewCartStore(_temp);
  const lostRollSelectionItemIds = useNewCartStore(_temp2);
  const [isNavigating, setIsNavigating] = useState(false);
  if (!cart?.items?.length) {
    return null;
  }
  let t0;
  if ($[0] !== cart.items || $[1] !== lostRollSelectionItemIds) {
    let t1;
    if ($[3] !== lostRollSelectionItemIds) {
      t1 = item => needsRollSelection({
        rollDriver: getRollDriver(item),
        rollCount: item.rollCount
      }, lostRollSelectionItemIds.includes(item.id));
      $[3] = lostRollSelectionItemIds;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    t0 = cart.items.some(t1);
    $[0] = cart.items;
    $[1] = lostRollSelectionItemIds;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const isMissingRollQuantity = t0;
  let t1;
  if ($[5] !== cart || $[6] !== isNavigating || $[7] !== router || $[8] !== setIsCartOpen) {
    t1 = function handleClick() {
      if (isNavigating || !cart) {
        return;
      }
      setIsNavigating(true);
      setIsCartOpen(false);
      trackCheckoutStarted(cart);
      pushDataLayer({
        event: "sg-checkout-started",
        value: cart.pricing.grandTotal,
        orderId: cart.id,
        eventCallback: () => router.push(`/store/checkout/${cart.id}`)
      });
    };
    $[5] = cart;
    $[6] = isNavigating;
    $[7] = router;
    $[8] = setIsCartOpen;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  const handleClick = t1;
  const t2 = isMissingRollQuantity ? "checkout-roll-quantity-error" : undefined;
  let t3;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <IconLock />;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== handleClick || $[12] !== isNavigating || $[13] !== t2) {
    t4 = <Button onClick={handleClick} size="xl" className="w-full" disabled={isNavigating} aria-describedby={t2}>{t3}Go to secure checkout</Button>;
    $[11] = handleClick;
    $[12] = isNavigating;
    $[13] = t2;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== isMissingRollQuantity) {
    t5 = isMissingRollQuantity && <p id="checkout-roll-quantity-error" className="text-sm text-destructive">{CHECKOUT_ROLL_QUANTITY_ERROR}</p>;
    $[15] = isMissingRollQuantity;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== t4 || $[18] !== t5) {
    t6 = <div className="flex flex-col gap-2">{t4}{t5}</div>;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
}
function _temp2(state_0) {
  return state_0.lostRollSelectionItemIds;
}
function _temp(state) {
  return state.setIsCartOpen;
}